import React, { useEffect, useState } from 'react';
import Button from '../../shared/components/ui/Button';
import { useForm } from 'react-hook-form';
import Table from '../../shared/components/layout/Table';
import EditTable from '../../shared/components/layout/EditTable';
import { transformData } from '../../super-admin/utils/transformData';
import Modal from '../../shared/components/ui/Modal';
import { ImportBlock } from '../components/forms/ImportBlock';
import AddNewBlock from '../components/forms/AddNewBlock';
import EditBlock from '../components/forms/EditBlock';
import EditProject from '../components/forms/EditProject';
import { EditBasement } from '../components/forms/EditBasement';
import { EditUnit } from '../components/forms/EditUnit';
import { EditGround } from '../components/forms/EditGround';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import UpdateLevel from '../components/forms/UpdateLevel';
import {
  createBLock,
  createLevel,
  cretaeUnit,
  deleteAccomodation,
  editBlock,
  editLevel,
  editUnits,
  getAllAccommodationsByProject,
  getAllBlocks,
  getBlockByID,
  getLevelById,
  deleteBlock,
  handleCheckBlockDelete,
  handleCheckLevelDelete,
  deleteLevel,
  handleCheckUnitDelete,
  deleteUnit,
  editProject,
  getProjectByID,
  getBuildingsByProjectId
} from '../services/api/implementation/impl';
import toast from 'react-hot-toast';
import { EditFloor } from '../components/forms/EditFloor';
import { useParams } from 'react-router-dom';
import { EditLevel } from '../components/forms/EditLevel';
import UpdateUnit from '../components/forms/UpdateUnit';
import leftarrow from '../../shared/assets/svg/left_arrow.svg';

import BlocksStatic from '../../builder/static/data/BlockStatic.json';
import generateLevelPayload from '../utils/generateLevelPayload';
import backbtnIcon from '../../shared/assets/svg/backbtn.svg';

import { getAllAccommodations } from '../services/api/implementation/impl';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import { Plus } from 'lucide-react';
import BlockHierarchy from '../components/layout/BlockHierarchy';

export const BlockDetails = () => {
  const queryClient = useQueryClient();
  const userId = Cookies.get('userId');

  const style = { width: `20%` };

  /* 
    Hooks
  */
  const { id: projectId } = useParams();

  // Track page view
  useEffect(() => {
    mixpanel.track('Block Details Viewed', {
      user_id: userId,
      project_id: projectId,
      timestamp: new Date().toISOString()
    });
  }, [userId, projectId]);

  /* 
    Hooks
  */
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm();

  /* 
    Local state
  */
  const [isOpenAddNewBlock, setIsOpenAddNewBlock] = useState(false);
  const [newBlockId, setNewBlockId] = useState(null);
  const [blockLevelStaticArray, setBlockLevelStaticArray] = useState(BlocksStatic);
  const [blocksArray, setBlocksArray] = useState([]);
  const [isEditBlockLevel, setIsEditBlockLevel] = useState(false);

  // Edit Project Modal states
  const [isOpenEditProject, setIsOpenEditProject] = useState(false);
  const [upShift, setUpShift] = useState(6);

  // For Level Unit Edit Modal
  const [levelsDyna, setLevelsDyna] = useState([]);
  const [currentLevelIndex, setCurrentLevelIndex] = useState(0);
  const [isOpenEditLevelUnitModal, setisOpenEditLevelModal] = useState(false);

  //For Unit view
  const [activeBlock, setActiveBlock] = useState([]);
  const [viewUnits, setViewUnits] = useState(false);
  const [blocksDynaWithLevels, setBlocksDynaWithLevels] = useState([]);
  const [activeLevelType, setActiveLevelType] = useState('');
  const [HeaderByLevelName, setHeaderByLevelName] = useState('');
  const [isAllUnitDataSubmitted, setisAllUnitDataSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [blockType, setBlockType] = useState('');
  const [type, setType] = useState();

  const [currentBlockName, setCurrentBlockName] = useState('');
  const [blockLevelNumber, setBlockLevelNumber] = useState(0);
  const [isSaved, setIsSaved] = useState(false);

  const [prevLevelData, setPrevLevelData] = useState([]);
  const { collapsed } = useSidebar();
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [canDelete, setCanDelete] = useState(null);
  const [deleteType, setDeleteType] = useState('');

  /*
    Data fetching
  */
  const { data: blocksDyna, refetch: refetchBlocks } = useQuery({
    queryKey: ['blocks', projectId],
    queryFn: () => getAllBlocks(projectId),
    enabled: !!projectId
  });

  useEffect(() => {
    if (projectId) {
      refetchBlocks();
    }
  }, [projectId]);

  const { data: blockDyna, refetch: refetchBlock } = useQuery({
    queryKey: ['block', newBlockId],
    queryFn: () => getBlockByID(newBlockId),
    enabled: !!newBlockId
  });

  // Queries for EditProject functionality
  const { data: buildingByProjectId, refetch: refetchBuildingByProjectId } = useQuery({
    queryKey: ['buildingByProjectId', projectId],
    queryFn: () => getBuildingsByProjectId(projectId),
    enabled: !!projectId
  });

  const { data: accommodations, refetch: refetchAccommodations } = useQuery({
    queryKey: ['accommodations', projectId],
    queryFn: () => getAllAccommodationsByProject(projectId)
  });

  const { data: projectData, refetch: refetchProjectData } = useQuery({
    queryKey: ['projectData', projectId],
    queryFn: () => getProjectByID(projectId),
    enabled: !!projectId
  });

  console.log('blockDyna', blockDyna);

  // const blocksDynaWithLevels = blocksDyna?.blocks?.filter((block) => block?.levels?.length > 0);
  /* 
    Effects
  */
  useEffect(() => {
    if (newBlockId) {
      refetchBlock(newBlockId);
      setCurrentBlockName(blockDyna?.name);
    }
  }, [newBlockId, refetchBlock, currentLevelIndex, currentBlockName]);

  //setting block type

  useEffect(() => {
    if (!blockType && blockDyna?.type) {
      setBlockType(blockDyna.type);
      setBlockLevelNumber(blockDyna?.numberOfLevels);
      setCurrentBlockName(blockDyna?.name);
    }
  }, [blockDyna, blockType, blockLevelNumber, setCurrentBlockName]);

  useEffect(() => {
    setType(blockDyna?.type);
  }, [blockDyna]);

  // This useEffect runs only after blockType is set
  useEffect(() => {
    if (blockLevelNumber && blockType && blockDyna) {
      const newBlocksArray = Array.from({ length: blockLevelNumber }, (_, index) => {
        const hasAccommodationUnitTypeResdential = accommodations?.some(
          (acc) => acc.unitType.toLowerCase() === 'residential'
        );
        console.log('hasAccommodationUnitTypeResdential', hasAccommodationUnitTypeResdential);

        const hasAccommodationUnitTypeCommercial = accommodations?.some(
          (acc) => acc.unitType.toLowerCase() === 'commercial'
        );
        console.log('hasAccommodationUnitTypeCommercial', hasAccommodationUnitTypeCommercial);
        console.log('accommodations', { accommodations });

        const accommodationStr = blockLevelStaticArray.accommodation_type;
        const dropdownPattern = /dropdown-(.*)/;
        const matches = accommodationStr.match(dropdownPattern);
        let dropdownArrayStr = matches && matches[1] ? matches[1] : '[]';

        // Convert the extracted string into a JS array
        let accommodationOptions;
        try {
          accommodationOptions = JSON.parse(dropdownArrayStr);
        } catch (error) {
          // If there's a parse error, fallback to a default array
          accommodationOptions = [
            { value: 'RESIDENTIAL', label: 'RESIDENTIAL' },
            { value: 'COMMERCIAL', label: 'COMMERCIAL' },
            { value: 'PARKING', label: 'PARKING' },
            { value: 'SERVICES', label: 'SERVICES' }
          ];
        }

        // Conditionally remove RESIDENTIAL if not present in accommodations
        if (!hasAccommodationUnitTypeResdential) {
          accommodationOptions = accommodationOptions.filter((opt) => opt.value !== 'RESIDENTIAL');
        }

        // Conditionally remove COMMERCIAL if not present in accommodations
        if (!hasAccommodationUnitTypeCommercial) {
          accommodationOptions = accommodationOptions.filter((opt) => opt.value !== 'COMMERCIAL');
        }

        // Recreate the accommodation_type string
        const newAccommodationType = `dropdown-${JSON.stringify(accommodationOptions)}`;

        const newBlock = {
          ...blockLevelStaticArray,
          level_name: blockType === 'Independent' ? `Row` : `Level ${index}`,
          accommodation_type: newAccommodationType,
          num_units: ''
        };

        setValue(`Level Name-${index}`, newBlock.level_name);
        return newBlock;
      });

      setBlocksArray(newBlocksArray);
    }
  }, [blockLevelNumber, blockType, blockDyna, blockLevelStaticArray, setValue]);
  console.log(blocksArray, 'blocksArray');

  useEffect(() => {
    if (blocksDyna) {
      if (blocksDyna) {
        const sorted =
          blocksDyna && blocksDyna.length > 0
            ? [...blocksDyna].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            : [];

        if (sorted.length > 0) {
          setBlocksDynaWithLevels(sorted);
          // Do not auto-select a block; show blocks table first
        }
      }
    }
  }, [blocksDyna]);

  /*
    Data mutation
  */
  const { mutate: handleAddBlock } = useMutation({
    mutationFn: (payload) => createBLock(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      type;
      setNewBlockId(data?.id);
      setBlockType(data?.type);
      setBlockLevelNumber(data?.numberOfLevels);
      setIsEditBlockLevel(true);
      setIsOpenAddNewBlock(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error creating new block', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating new block');
    }
  });
  const handlePreviewCreatedBlock = async (data) => {
    // Filter the data to include only the relevant levels
    const filteredData = {};
    for (let i = 0; i < blockLevelNumber; i++) {
      filteredData[`Level Name-${i}`] = data[`Level Name-${i}`];
      filteredData[`No of Units-${i}`] = data[`No of Units-${i}`];
      filteredData[`Floor Type-${i}`] = data[`Floor Type-${i}`];
    }

    const payload = generateLevelPayload({
      ...filteredData,
      block_id: blockDyna?.id,
      project_id: projectId
    });

    try {
      const res = await createLevel(payload);
      setisOpenEditLevelModal(true);
      setLevelsDyna(res);
    } catch (error) {
      console.error('Error creating level:', error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Failed to create level. Please try again.'
      );
    }
  };

  const handleEditLevel = async (data) => {
    console.warn('Data: testing', data);
    setPrevLevelData((prev) => [...prev, data]);
    // Extracting unit names and accommodation names
    let units = Object.keys(data)
      .filter((key) => key.startsWith('Unit Name-'))
      ?.map((key, index) => {
        const unitName = data[key];
        const accommodationKey = `Accommodation Name-${index}`;
        const accommodationName = data[accommodationKey] || '';

        console.warn(accommodationName, 'accommodationName');

        return {
          unit_name: unitName,
          accomodation_id: parseInt(accommodationName)
        };
      });

    // Validate units
    const allFieldsFilled = units.every((unit) => unit.unit_name && unit.accomodation_id);
    if (!allFieldsFilled) {
      toast.error('Please fill n all the fields');
      return;
    }

    let payload = {
      project_id: projectId,
      block_id: blockDyna?.id,
      level_id: levelsDyna[currentLevelIndex].id, // Use the current level's ID
      units
    };

    try {
      const response = await cretaeUnit(payload);
      if (currentLevelIndex < blockLevelNumber - 1) {
        setCurrentLevelIndex(currentLevelIndex + 1);
        setisOpenEditLevelModal(true); // Reopen the modal with the next level
      } else {
        setisOpenEditLevelModal(false); // Close the modal if it's the last level
        setisAllUnitDataSubmitted(true);
        setIsEditBlockLevel(false);
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || 'Failed to create units. Please try again.'
      );
      console.error('Unit creation error:', err);
    }
  };

  const handleSaveAddBlock = async () => {
    setIsSaved(true);
    await refetchBlocks(projectId); // Refresh the block data from API
    await refetchBlock(newBlockId); // Refresh the specific block data

    // Resetting state variables
    setIsEditBlockLevel(false);
    setisAllUnitDataSubmitted(false);
    setLevelsDyna([]); // Reset levels data
    setBlocksArray([]); // Reset blocks data
    setBlockLevelNumber(0); // Reset 0the level number
    setBlockType(''); // Reset block type
    setCurrentBlockName(''); // Reset block name
    setNewBlockId(null); // Clear new block ID
    setIsSaved(false);
    setCurrentLevelIndex(0); // Reset the current level index

    // If you want to reset form fields as well
    reset(); // useForm's reset to clear all fields

    toast.success('Block saved successfully');
    window.location.reload();
    await refetchBlocks(projectId);
  };
  blockType;

  const blockDataByIdFormat = ['id', 'name', 'floorType', 'noOfUnits', 'actions'];

  const BlockDataId =
    blockDyna?.levels?.map((item) => transformData(item, blockDataByIdFormat)) || [];

  useEffect(() => {
    if (viewUnits && blockDyna?.levels && activeBlock?.[0]?.id) {
      // Use the ID of the currently active level to update the active block state
      const updatedActiveBlock = blockDyna?.levels?.filter(
        (item) => parseInt(item.id) === parseInt(activeBlock?.[0]?.id)
      );
      setActiveBlock(updatedActiveBlock);
    }
  }, [blockDyna]);

  const handleViewForType = (id) => {
    const filterType = blockDyna?.levels?.filter((item) => parseInt(item.id) === parseInt(id));
    setActiveBlock(filterType);
    setActiveLevelType(filterType[0]?.floorType);
    setHeaderByLevelName(filterType[0]?.name);
    setViewUnits(true);
  };

  const handleSelectBlockChange = (event) => {
    setNewBlockId(event.target.value);
  };

  const goBackToBlocks = () => {
    setViewUnits(false);
    setActiveBlock([]);
    setActiveLevelType('');
    setHeaderByLevelName('');
    setNewBlockId(null);
  };

  const backToLevels = () => {
    setViewUnits(false);
  };

  // Unit heders

  const commercialHeader = [
    'Unit Name',
    'Acc. Type',
    'Build Up Area',
    'Carpet Area',
    'Loading Factor',
    'Super Build Up',
    'Actions'
  ];

  const residentialHeader = [
    'Unit Name',
    'Acc. Type',
    'Acc. Name',
    ...(type === 'Independent' ? ['Plot Area'] : []),
    'Build Up Area',
    'Carpet Area',
    'Actions'
  ];

  const parkingHeader = ['Unit Name', 'Acc. Type', 'Acc. Name', 'Area', 'Electrified', 'Actions'];

  const commercialDataFields = [
    'unitName',
    'accommodationType',
    'buildUpArea',
    'carpetArea',
    'loadingFactor',
    'superBuiltUpArea',
    'actions',
    'id'
  ];
  const residentialDataFields = [
    'unitName',
    'accommodationType',
    'accommodationName',
    ...(type === 'Independent' ? ['plotArea'] : []),
    'buildUpArea',
    'carpetArea',
    'actions',
    'id'
  ];

  const parkingDataFields = [
    'unitName',
    'accommodationType',
    'accommodationName',
    'buildUpArea',
    'electrified',
    'actions',
    'id'
  ];

  const headers =
    activeLevelType === 'PARKING'
      ? parkingHeader
      : activeLevelType === 'COMMERCIAL'
        ? commercialHeader
        : residentialHeader;
  const dataFields =
    activeLevelType === 'PARKING'
      ? parkingDataFields
      : activeLevelType === 'COMMERCIAL'
        ? commercialDataFields
        : residentialDataFields;

  const dataFieldUnits = activeBlock?.[0]?.units?.map((item) =>
    transformData(
      {
        ...item,
        accommodationName: item?.accommodation?.name,
        accommodationType: item?.accommodation?.accomodationType,
        carpetArea: item?.accommodation?.carpetArea,
        plotArea: item?.accommodation?.plotArea,
        buildUpArea: item?.accommodation?.buildUpArea,
        superBuiltUpArea: item?.accommodation?.superBuiltUpArea,
        loadingFactor: item?.accommodation?.loadingFactor,
        electrified: item?.accommodation?.electrified
      },
      dataFields
    )
  );

  const unitDetailsForEdit = activeBlock?.[0]?.units;
  // const dataFieldUnits = activeBlock?.[0]?.units;

  // Edit Codes
  const [isEditingBlock, setIsEditingBlock] = useState(false);
  const [isEditUnit, setIsEditUnit] = useState(false);
  const [UnitId, setUnitId] = useState(null);

  const { mutate: handleEditBlock } = useMutation({
    mutationFn: (payload) => {
      editBlock(newBlockId, payload);
    },
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      toast.success('Block Updated successfully');
      setIsEditingBlock(false);
      setNewBlockId(null);
      await refetchBlocks(projectId);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error  updating block', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error Updating new block');
    }
  });

  const { mutate: handleEditUnits } = useMutation({
    mutationFn: (payload) => editUnits(UnitId, payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      toast.success('UnitId Updated successfully');
      setIsEditUnit(false);
      queryClient.invalidateQueries(['block', newBlockId]);
      await refetchBlock(newBlockId);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating unit', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating unit');
    }
  });

  // EditProject mutation
  const { mutate: handleEditProject, isLoading: isEditingProject } = useMutation({
    mutationFn: (updatedProject) => {
      if (!updatedProject) {
        throw new Error('updatedProject is null or undefined');
      }

      if (projectId == null) {
        throw new Error('projectId is null or undefined');
      }

      let parsedLandId;
      try {
        parsedLandId = updatedProject.land_id != null ? parseInt(updatedProject.land_id, 10) : null;
        console.log('Parsed land_id:', parsedLandId);
      } catch (error) {
        console.error('Error parsing land_id:', error);
        throw new Error(`Failed to parse land_id: ${error.message}`);
      }

      const projectToEdit = {
        ...updatedProject,
        land_id: parsedLandId
      };

      console.log('Project to edit:', JSON.stringify(projectToEdit, null, 2));

      return editProject(projectId, projectToEdit);
    },
    onMutate: (variables) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Edit Project Started', {
        user_id: userId,
        project_id: projectId,
        project_name: variables?.name,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, variables) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        // Handle as error
        console.error('Error editing project:', result);
        toast.error(result?.response?.data?.message || result?.message || 'Error editing project');

        mixpanel.track('Edit Project Failed', {
          user_id: userId,
          project_id: projectId,
          project_name: variables?.name,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      // Handle success
      console.log('Edit project succeeded');
      toast.success('Project edited successfully');
      setIsOpenEditProject(false);
      await refetchProjectData(projectId);
      await refetchBuildingByProjectId();

      mixpanel.track('Edit Project Success', {
        user_id: userId,
        project_id: projectId,
        project_name: variables?.name || result?.name,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err, variables) => {
      setIsSubmitting(false);
      console.error('Error editing project:', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error editing project');

      mixpanel.track('Edit Project Failed', {
        user_id: userId,
        project_id: projectId,
        project_name: variables?.name,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const handleEditUnitById = (id) => {
    setUnitId(id);
    setIsEditUnit(!isEditUnit);
  };
  const handleCloseEditUnitModal = async () => {
    setIsEditUnit(false);
    await refetchBlock();
  };
  const isTypingNow = (value, index) => {
    const updatedBlocksArray = [...blocksArray];

    if (index === 0 && value.startsWith('Level ')) {
      // Extract the number from the first level name
      const levelNumber = parseInt(value.replace('Level ', ''), 10);

      if (!isNaN(levelNumber)) {
        // Update the first row
        updatedBlocksArray[0].level_name = value;

        // Propagate the change to subsequent rows
        for (let i = 1; i < updatedBlocksArray.length; i++) {
          updatedBlocksArray[i].level_name = `Level ${levelNumber + i}`;
        }

        // Update the form values dynamically using setValue for each field
        updatedBlocksArray.forEach((block, idx) => {
          setValue(`Level Name-${idx}`, block.level_name); // Update form state for each level name
        });

        // Update the state with the new array
        setBlocksArray(updatedBlocksArray);
      } else {
        toast.error('Please enter a valid number after "Level"');
      }
    } else if (value.startsWith('Level ')) {
      // Handle updates to other rows that start with "Level"
      const levelNumber = parseInt(value.replace('Level ', ''), 10);

      if (!isNaN(levelNumber)) {
        // Update the specific row
        updatedBlocksArray[index].level_name = value;
        setBlocksArray(updatedBlocksArray);
        setValue(`Level Name-${index}`, value); // Update form state for the specific level name
      } else {
        toast.error('Please enter a valid number after "Level"');
      }
    } else if (!value.startsWith('Level')) {
      // Handle updates to No of Units, Floor Type, or other fields
      updatedBlocksArray[index].num_units = value;
      setBlocksArray(updatedBlocksArray);
      setValue(`No of Units-${index}`, value);
    } else {
      // If none of the conditions match, show an error to prevent incorrect input
      toast.error('You can only edit the number after "Level"');
    }
  };

  // console.log("isTypingNow", isTypingNow);
  const [isUpdateUnitModalOpen, setIsUpdateUnitModalOpen] = useState(false);
  const [isUpdateLevelModalOpen, setIsUpdateLevelModalOpen] = useState(false);

  const addUnitHandler = () => {
    console.log('addUnitHandler');
    setIsUpdateUnitModalOpen(true);
  };
  const addLevelHandler = () => {
    console.log('addLevelHandler');
    setIsUpdateLevelModalOpen(true);
  };

  const handleAddFloatingLevel = () => {
    const nextIndex = blocksArray.length;
    const baseRow = blocksArray[0] || blockLevelStaticArray;
    const nextLevelName = blockType === 'Independent' ? 'Row' : `Level ${nextIndex}`;

    const newLevelRow = {
      ...baseRow,
      level_name: nextLevelName,
      num_units: ''
    };

    setBlocksArray((prev) => [...prev, newLevelRow]);
    setBlockLevelNumber((prev) => prev + 1);
    setValue(`Level Name-${nextIndex}`, nextLevelName);
    setValue(`No of Units-${nextIndex}`, '');
  };

  const handleUpdateUnit = async (payload) => {
    console.log('handleUpdateUnit', payload);
    await cretaeUnit(payload);
    await refetchBlock(newBlockId);
    // queryClient.invalidateQueries(['block', newBlockId]);
    setIsUpdateUnitModalOpen(false);
    queryClient.invalidateQueries(['block', newBlockId]);
  };

  const handleUpdateLevel = async (payload) => {
    console.log('handleUpdateLevel', payload);
    await createLevel(payload);
    await refetchBlock(newBlockId);
    setIsUpdateLevelModalOpen(false);
    queryClient.invalidateQueries(['block', newBlockId]);
  };

  console.log(blocksArray, 'setBlocksArray[0]?.floorType');

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckBlockDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const BlockName = blockDyna?.name || 'block';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: BlockName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: BlockName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteLevel } = useMutation({
    mutationFn: (id) => handleCheckLevelDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const level = blockDyna?.levels?.find((item) => parseInt(item.id) === parseInt(id));
      const LevelName = level?.name || 'level';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: LevelName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: LevelName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteUnit } = useMutation({
    mutationFn: (id) => handleCheckUnitDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const unit = activeBlock?.[0]?.units?.find((item) => parseInt(item.id) === parseInt(id));
      const UnitName = unit?.unitName || 'unit';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: UnitName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: UnitName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteBlock(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Block Deleted Successfully');
      refetchBlocks();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting block', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting block');
    }
  });

  const { mutate: handleDeleteLevelFn } = useMutation({
    mutationFn: (payload) => deleteLevel(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Level Deleted Successfully');
      await refetchBlock();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting Level', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting Level');
    }
  });

  const { mutate: handleDeleteUnitFn } = useMutation({
    mutationFn: (payload) => deleteUnit(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Unit Deleted Successfully');
      refetchBlock();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting Unit', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting Unit');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    if (deleteType === 'Block') {
      handleDeleteFn(payload);
    }

    if (deleteType === 'Level') {
      handleDeleteLevelFn(payload);
    }

    if (deleteType === 'Unit') {
      handleDeleteUnitFn(payload);
    }
  };

  // Add this function to ensure latest data is used when clicking a level
  const handleLevelClick = async (id) => {
    await refetchBlock();
    handleViewForType(id);
  };

  // New: build blocks table rows and table handlers
  const blockTableFormat = ['id', 'name', 'type', 'numberOfLevels', 'actions'];
  const blocksTableRows =
    blocksDynaWithLevels?.map((item) => transformData(item, blockTableFormat)) || [];

  const handleBlockRowClick = (id) => {
    setViewUnits(false);
    setActiveBlock([]);
    setNewBlockId(id);
  };

  const handleEditBlockRow = (id) => {
    setNewBlockId(id);
    setIsEditingBlock(true);
  };

  const handleDeleteBlockRow = (id) => {
    setDeleteType('Block');
    handleCheckDelete(id);
  };

  return (
    <>
      {isUpdateLevelModalOpen && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Update Levels'}
          width={55}
          onClose={() => setIsUpdateLevelModalOpen(false)}>
          <UpdateLevel
            blockId={newBlockId}
            levelId={activeBlock[0]?.id}
            floorTypeOptions={blocksArray[0]?.accommodation_type}
            onClose={() => setIsUpdateLevelModalOpen(false)}
            handleUpdateLevel={handleUpdateLevel}
          />
        </Modal>
      )}
      {isUpdateUnitModalOpen && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Update Units'}
          width={55}
          onClose={() => setIsUpdateUnitModalOpen(false)}>
          <UpdateUnit
            blockId={newBlockId}
            levelId={activeBlock[0]?.id}
            activeLevelType={activeLevelType}
            onClose={() => setIsUpdateUnitModalOpen(false)}
            handleUpdateUnit={handleUpdateUnit}
          />
        </Modal>
      )}
      {/* EDITING CODES  */}
      {isEditingBlock && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={68}
          name={'Edit block'}
          onClose={() => {
            setIsEditingBlock(false);
            setNewBlockId(null);
          }}>
          <EditBlock
            data={blockDyna}
            blockId={newBlockId}
            isSubmitting={isSubmitting}
            setIsEditingBlock={setIsEditingBlock}
            onProceed={handleEditBlock}
            onClose={() => {
              setIsEditingBlock(false);
              setNewBlockId(null);
            }}
            buildingByProjectId={buildingByProjectId}
            setIsOpenEditProject={setIsOpenEditProject}
          />
        </Modal>
      )}

      {isEditUnit && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Edit Unit'}
          width={60}
          onClose={handleCloseEditUnitModal}>
          <EditUnit
            handleEditUnit={handleEditUnits}
            unitId={UnitId}
            isSubmitting={isSubmitting}
            activeLevelType={activeLevelType}
            data={unitDetailsForEdit}
            onClose={handleCloseEditUnitModal}
          />
        </Modal>
      )}
      {isOpenAddNewBlock && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={68}
          name={'Add New Block'}
          onClose={() => setIsOpenAddNewBlock(!isOpenAddNewBlock)}>
          <AddNewBlock
            setIsOpenAddNewBlock={setIsOpenAddNewBlock}
            onProceed={handleAddBlock}
            isSubmitting={isSubmitting}
            projectId={projectId}
            onClose={() => setIsOpenAddNewBlock(false)}
            setisSubmitting={setIsSubmitting}
            buildingByProjectId={buildingByProjectId}
            setIsOpenEditProject={setIsOpenEditProject}
          />
        </Modal>
      )}

      {/* Edit Project Modal */}
      {isOpenEditProject && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={88}
          name="Edit project"
          onClose={() => setIsOpenEditProject(false)}
          upShift={upShift * 10}>
          <EditProject
            id={projectId}
            ProjectData={projectData}
            upShift={upShift}
            isSubmitting={isSubmitting}
            setUpShift={setUpShift}
            onSubmit={handleEditProject}
            onClose={() => setIsOpenEditProject(false)}
          />
        </Modal>
      )}

      {isOpenEditLevelUnitModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Unit Detailing'}
          width={55}
          onClose={async () => {
            setisOpenEditLevelModal(false);
            const block = await refetchBlock();
            // Find the current level id (after unit creation, usually the last edited level)
            let levelId = null;
            if (levelsDyna && levelsDyna.length > 0) {
              // If only one level, use its id; otherwise, use the last one edited
              levelId =
                levelsDyna.length === 1
                  ? levelsDyna[0]?.id
                  : levelsDyna[currentLevelIndex]?.id || levelsDyna[0]?.id;
            }
            if (levelId) {
              handleViewForType(levelId);
            }
          }}
          hideClose={true}>
          <EditLevel
            handleEditLevel={handleEditLevel}
            data={levelsDyna}
            currentLevelIndex={currentLevelIndex}
            noOflevel={blockLevelNumber}
            setCurrentLevelIndex={setCurrentLevelIndex}
            allAccommodations={accommodations}
            onClose={() => {
              setisOpenEditLevelModal(false);
              refetchBlock();
            }}
            blockType={blockType}
            blockName={currentBlockName}
            blockSaved={isSaved}
            prevLevelData={prevLevelData}
          />
        </Modal>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || `this ${deleteType === 'Block' ? 'block' : deleteType === 'Level' ? 'level' : deleteType === 'Unit' ? 'unit' : 'item'}`}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            {deleteType !== 'Unit' ? (
              <p className="text-center">
                Looks like this{' '}
                {deleteType === 'Block' ? 'block' : deleteType === 'Level' ? 'level' : 'item'} has
                dependencies, please delete following{' '}
                {deleteType === 'Block' ? 'levels' : deleteType === 'Level' ? 'units' : 'item'} to
                proceed
              </p>
            ) : (
              <p className="text-center">Looks like this unit is already booked.</p>
            )}
            {deleteType !== 'Unit' && (
              <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
                {resData &&
                  resData.reason?.map((r, index) => (
                    <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                      {index + 1}.{r}
                      {index < resData.reason.length - 1 ? ', ' : ''}
                    </span>
                  ))}
              </div>
            )}
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={
              deleteType === 'Block'
                ? 'block'
                : deleteType === 'Level'
                  ? 'level'
                  : deleteType === 'Unit'
                    ? 'unit'
                    : 'item'
            }
            onClose={() => setCanDelete(null)}
            data={
              deleteType === 'Block'
                ? blocksDyna
                : deleteType === 'Level'
                  ? BlockDataId
                  : deleteType === 'Unit'
                    ? dataFieldUnits
                    : []
            }
            type={
              deleteType === 'Block'
                ? 'block'
                : deleteType === 'Level'
                  ? 'level'
                  : deleteType === 'Unit'
                    ? 'unit'
                    : 'item'
            }
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      <div
        className={`w-full flex flex-col transition-all duration-300 ease-in-out mt-3 pl-5 pr-5 bg-gray-100 overflow-hidden `}>
        {(isEditBlockLevel || isAllUnitDataSubmitted) && (
          <div className="flex bg-white p-3 items-center justify-end rounded-md">
            <div className="flex gap-3">
              {isEditBlockLevel && (
                <Button onClick={handleSubmit(handlePreviewCreatedBlock)} type="submit">
                  Proceed
                </Button>
              )}
              {isAllUnitDataSubmitted && <Button onClick={handleSaveAddBlock}>Save</Button>}
            </div>
          </div>
        )}
        {!isEditBlockLevel && !isAllUnitDataSubmitted && (newBlockId || viewUnits) && (
          <div className="flex  bg-white p-3 items-center justify-between rounded-md">
            <h3 className="text-xl font-semibold cursor-pointer flex gap-2 items-center">
              <span className="text-black" onClick={goBackToBlocks}>
                {`${currentBlockName ? ` ${currentBlockName}` : ''}`}
              </span>
              {newBlockId && !viewUnits && (
                <>
                  <span className="text-gray-400">›</span>
                  <span>{'Level'}</span>
                </>
              )}
              {viewUnits && (
                <>
                  <span className="text-gray-400">›</span>
                  <span className="text-black" onClick={backToLevels}>
                    {`${HeaderByLevelName ? ` ${HeaderByLevelName}` : ''}`}
                  </span>
                  <span className="text-gray-400">›</span>
                  <span>{'Unit'}</span>
                </>
              )}
            </h3>
            <div className="flex gap-3">
              {isEditBlockLevel && (
                <Button onClick={handleSubmit(handlePreviewCreatedBlock)} type="submit">
                  Proceed
                </Button>
              )}
              {isAllUnitDataSubmitted && <Button onClick={handleSaveAddBlock}>Save</Button>}
            </div>
          </div>
        )}

        <div className="mt-5 h-full">
          {isEditBlockLevel && (
            // Usage in the EditTable component
            <div className="Editlevel-table-container">
              <style>{`
                  .Editlevel-table-container .table-body {
                    position: static !important;
                    overflow-y: visible !important;
                    max-height: none !important;  
                    height: auto !important;
                    top: auto !important;
                    padding-bottom: 0 !important;
                  }
                  .Editlevel-table-container .table-container {
                    height: auto !important;
                  }
                  .Editlevel-table-container > div {
                    height: auto !important;  
                  }
                `}</style>

              <EditTable
                headers={['Level Name', 'Floor Type', 'No of Units']}
                data={blocksArray}
                isEditEnable={false}
                onRegister={register}
                blockType={blockType}
                editTableType={'LevelEdit'}
                onType={(value, index) => isTypingNow(value, index)} // Pass the index here
                identifier={'id'}
                isWrap={true}
              />
            </div>
          )}

          {isEditBlockLevel && (
            <button
              type="button"
              onClick={handleAddFloatingLevel}
              className="fixed bottom-8 right-8 z-50 h-14 w-14 rounded-full bg-[#2B6777] text-white shadow-lg hover:bg-[#1f4f5c] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2B6777]"
              aria-label="Add level">
              <Plus className="mx-auto" size={24} />
            </button>
          )}

          {!isEditBlockLevel && (
            <BlockHierarchy
              blocksRows={blocksTableRows}
              levelsRows={BlockDataId}
              unitsRows={dataFieldUnits}
              unitHeaders={headers}
              selectedBlockId={isEditingBlock ? null : newBlockId}
              isViewUnits={viewUnits}
              onClickBlock={handleBlockRowClick}
              onEditBlock={handleEditBlockRow}
              onDeleteBlock={handleDeleteBlockRow}
              onAddBlock={() => setIsOpenAddNewBlock(true)}
              onClickLevel={handleLevelClick}
              onDeleteLevel={(id) => {
                setDeleteType('Level');
                handleDeleteLevel(id);
              }}
              onAddLevel={addLevelHandler}
              onEditUnit={(id) => handleEditUnitById(id)}
              onDeleteUnit={(id) => {
                setDeleteType('Unit');
                handleDeleteUnit(id);
              }}
              onAddUnit={addUnitHandler}
              showAddButtons={
                !isEditBlockLevel &&
                !isOpenAddNewBlock &&
                !isAllUnitDataSubmitted &&
                !isUpdateLevelModalOpen &&
                !isUpdateUnitModalOpen &&
                !isEditingBlock &&
                !isEditUnit
              }
            />
          )}
        </div>
      </div>
    </>
  );
};
